import { FC } from 'react';
import { Center, CenterProps } from '@chakra-ui/react';

export const CenteredContainer: FC<CenterProps> = ({
  children,
  width = 392,
  ...props
}) => (
  <Center
    width="100%"
    maxWidth={width}
    flexDirection="column"
    height="100%"
    margin="auto"
    textAlign="center"
    {...props}
  >
    {children}
  </Center>
);
